export default __webpack_public_path__ + "static/media/ambasador2a.8c744ca3.png";